import Modifier from 'ember-modifier';
import { service } from '@ember/service';
import type StocktakingService from 'bcl/services/stocktaking';
import { registerDestructor } from '@ember/destroyable';
import { tracked } from '@glimmer/tracking';
import type StocktakingModel from 'bcl/models/stocktaking';
import { action } from '@ember/object';

interface ContinuousSavingStocktakingSignature {
  Args: {
    Positional: [StocktakingModel];
    // Named: {
    //   //
    // };
  };
  Element: Element;
}

export default class ContinuousSavingStocktaking extends Modifier<ContinuousSavingStocktakingSignature> {
  @service declare stocktaking: StocktakingService;

  interval: number;
  constructor(owner, args) {
    super(owner, args);
    this.interval = setInterval(async () => {
      if (this.isDestroyed) {
        return clearInterval(this.interval);
      }
      await this.trySaveStocktaking();
    }, 1000);
    registerDestructor(this, this.unregister);
  }

  modify(
    el: Element,
    positional: ContinuousSavingStocktakingSignature['Args']['Positional']
    // named: ContinuousSavingStocktakingSignature['Args']['Named']
  ) {
    this.stocktaking.enter(positional[0]);
  }

  unregister(self: this) {
    self.stocktaking.leave();
    return clearInterval(self.interval);
  }
  @action
  async trySaveStocktaking() {
    await this.stocktaking.saveNewChanges();
  }
}
